import DarkModeRoundedIcon from '@mui/icons-material/DarkModeRounded';
import LightModeRoundedIcon from '@mui/icons-material/LightModeRounded';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Tooltip from '@mui/material/Tooltip';
import { useAppThemeMode } from './AppThemeProvider';

export default function ThemeModeToggle() {
  const { mode, toggleColorMode } = useAppThemeMode();

  return (
    <Tooltip title={mode === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}>
      <Paper
        elevation={6}
        sx={{
          position: 'fixed',
          top: 16,
          right: 16,
          zIndex: (theme) => theme.zIndex.tooltip + 1,
          borderRadius: '999px',
        }}
      >
        <IconButton onClick={toggleColorMode} color="inherit" aria-label="toggle theme">
          {mode === 'dark' ? <LightModeRoundedIcon /> : <DarkModeRoundedIcon />}
        </IconButton>
      </Paper>
    </Tooltip>
  );
}
